import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../../../utils/apiData";
import "./CaseStudyCard.scss";

const CaseStudyCard = ({ img, tag, title, text, k, slug }) => {
  const navigate = useNavigate();
  return (
    <div
      className="case_study_card wow fadeInUp"
      data-wow-delay={`${k * 0.1}s`}
    onClick={() => navigate(`/blog/${slug}`)}
    >
      <div className="img_wrap">
        <img src={`${baseUrl}/${img}`} alt="img" />
      </div>
      <div className="content_box">
        <p className="t-12 wow fadeInUp">{tag}</p>
        <h4 className="wow fadeInUp" data-wow-delay="0.1s">
          {title}
        </h4>
      
        <p className="t-16 wow fadeInUp" data-wow-delay="0.2s">
          {text}
        </p>
      </div>
    </div>
  );
};

export default CaseStudyCard;
